

export interface ButtonConfig {
  id: string;
  translationKey: string; // key in Translation object (e.g., "scheme", "grievance")
  order: number; // Default order when buttonOrder param not provided
  enabled: boolean; // Base visibility (can be overridden by hideButtons param)
}

export const buttonConfigs: ButtonConfig[] = [
  {
    id: "110",
    translationKey: "scheme",
    order: 1,
    enabled: true,
  },
  {
    id: "111",
    translationKey: "grievance",
    order: 2,
    enabled: true,
  },
  {
    id: "112",
    translationKey: "hospitals",
    order: 3,
    enabled: true,
  },
  {
    id:"113",
    translationKey:"survey",
    order: 4,
    enabled: true,
  },
  {
    id: "114",
    translationKey: "services",
    order: 5,
    enabled: true,
  },
  {
    id: "115",
    translationKey: "jobs",
    order: 6,
    enabled: true,
  },
  {
    id: "116",
    translationKey: "rewardPoints",
    order: 7,
    enabled: true,
  },
 
  
  // Add new buttons here:
  // {
  //   id: "survey",
  //   translationKey: "survey",
  //   order: 4,
  //   enabled: true,
  // },
];

